import {Component, Inject, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AdService} from '@services/ad.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-bug',
  templateUrl: './bug.component.html',
  styleUrls: ['./bug.component.scss']
})
export class BugComponent implements OnInit {

    favorite: Favorite;
    user: User = Object.assign({}, EMPTY_USER);
    loading = false;
    comment = '';
    error = '';

    constructor(
        private adService: AdService,
        public dialogRef: MatDialogRef<BugComponent>,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.favorite = this.data.favorite;
        this.user = this.authenticationService.currentUser;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.loading = true
        this.adService.sendBug(this.favorite, this.error, this.comment).subscribe(data => {
            this.loading = false;
            this.dialogRef.close(true);
            this.alertService.success('Message envoyé, merci pour le signalement.');
        }, err => {
            this.loading = false;
            this.alertService.error('Une erreur est survenue.');
        });
    }
}
